'use client';
import React from 'react';
import { Icon, Button } from '@benzinga/core-ui';
import { AddAllToWatchlist } from '@benzinga/watchlist-ui';
import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons/faStar';

interface AddAllWatchlistTableButtonProps {
  isActive: boolean;
  symbols: string[];
}

export const AddAllWatchlistTableButton: React.FC<AddAllWatchlistTableButtonProps> = ({ isActive, symbols }) => {
  return (
    <>
      {!isActive ? (
        <>
          <AddAllToWatchlist
            buttonText={'Add All to Watchlist'}
            buttonVariant={'flat-blue'}
            showIcon={true}
            symbols={symbols}
            variant="default"
          />
        </>
      ) : (
        <Button aria-label="Add to watchlist" size={'md'} variant={'flat-blue'}>
          <Icon className="mr-1" icon={faStarRegular} />
          Add All To Watchlist
        </Button>
      )}
    </>
  );
};
